export default "__VITE_ASSET__Cbrdis$4__"